import { CDate } from 'src/utils/CDate';
import { SortDirectionEnum } from 'src/utils/types';
import { createTableColumn } from '../types';

type Options = {
  includeTime?: boolean;
  defaultSort?: boolean;
  useFilter?: boolean;
};

export const tableColumnCreatedDate = createTableColumn<Options>(
  (title, { includeTime, defaultSort, useFilter = true, ...other } = {}) => ({
    title,
    sortPropertyName: 'CreatedDate',
    filter: useFilter
      ? {
          type: 'date',
          propertyName: 'CreatedDate',
        }
      : undefined,
    defaultSortDirection: defaultSort ? SortDirectionEnum.DESC : undefined,
    className: 'date text-center',
    renderValue: ({ CreatedDate }) =>
      includeTime ? CDate.formatStringToDate(CreatedDate, 'M/dd/yyyy HH:mm:ss') : CDate.formatStringToDate(CreatedDate),
    ...other,
  })
);
